// {{ AURA-X: Modify - 配置 antd-mobile React 19 兼容性 }}
// {{ Source: antd-mobile 官方文档 v5-for-19 }}
import { unstableSetRender } from 'antd-mobile' // Support since version ^5.40.0
import { createRoot } from 'react-dom/client'

// 配置 antd-mobile 使用 React 19 的 createRoot API
unstableSetRender((node: any, container: any) => {
  container._reactRoot ||= createRoot(container)
  const root = container._reactRoot
  root.render(node)
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0))
    root.unmount()
  }
})

import App from './App'
import { getLocaleFromUrl, setDocumentLang } from './i18n/locale-utils'

setDocumentLang(getLocaleFromUrl())

// 使用 React 19 的 createRoot API 渲染应用
// {{ AURA-X: Modify - 添加类型断言解决Emotion JSX与React 19类型冲突. Approval: 寸止(ID:1730070000). }}
const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render((<App />) as any)
}
